import type { ReactNode } from 'react'
import { Navigate, useLocation } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { useAuth } from './useAuth'

/**
 * Schützt Routen. Solange die gespeicherte Session geprüft wird, darf nicht auf
 * /login umgeleitet werden — sonst fliegt jeder Reload den Nutzer aus der App.
 */
export default function RequireAuth({ children }: { children: ReactNode }) {
  const { session, isLoading } = useAuth()
  const location = useLocation()
  const { t } = useTranslation()

  if (isLoading) {
    return (
      <div className="text-roast-500 dark:text-crema-300/70 flex min-h-full items-center justify-center p-8 text-sm">
        {t('auth.checkingSession')}
      </div>
    )
  }

  if (!session) {
    return <Navigate to="/login" replace state={{ from: location.pathname }} />
  }

  return <>{children}</>
}
